import script from "./InputGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./InputGroup.vue?vue&type=script&setup=true&lang=js"

import "./InputGroup.vue?vue&type=style&index=0&id=50401b1d&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_ygitl4qwkjirupiphave5nrawa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50401b1d"]])

export default __exports__